export default function squareArrow({ className }: { className?: string }) {
  return (
    <svg
      width='70'
      height='7'
      viewBox='0 0 70 7'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path d='M64 3.5H0' stroke='url(#paint0_linear_455_1625)' />
      <rect x='64' y='0.5' width='6' height='6' fill='#474646' />
      <defs>
        <linearGradient
          id='paint0_linear_455_1625'
          x1='0'
          y1='4'
          x2='64'
          y2='4'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-opacity='0' />
          <stop offset='1' stop-color='#474646' />
        </linearGradient>
      </defs>
    </svg>
  );
}
